<div class="border-top">
    <div class="container-md pt-2 pb-sm-2 w-auto float-right">
        <div class="row align-items-center justify-content-between">
            <div class="col-12 col-sm-auto pr-sm-0">
                <label class="input-group" style="margin-right:9.5rem;">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <div class="swapa-search"></div>
                        </span>
                    </div>
                    <input [(ngModel)]="searchText"
                           name="txtSearch"
                           #txtSearch
                           (ngModelChange)="onTextChange($event)"
                           type="text"
                           class="form-control"
                           placeholder="Search {{searchContent.Heading}}" />
                </label>
            </div>
            <div class="col-auto d-flex align-items-center pl-sm-2">
                <span class="pb-1 pl-sm-2 h3 m-0 font-weight-normal">
                    <button [disabled]="(!filterMetadata.count) ||(filterMetadata.count==1)" class="btn btn-link pr-2 p-0" (click)="findPrev()"><h3>&and;</h3></button>
                    <button [disabled]="(!filterMetadata.count)|| (filterMetadata.count==1)" class="btn btn-link pr-2 p-0" (click)="findNext()"><h3>&or;</h3></button>
                </span>
                <span class="pl-2 pl-sm-0 order-sm-first">
                    {{ index.count }}
                    of  {{ filterMetadata.count }} results
                </span>
            </div>
            <div class="col-auto ml-md-0 ml-auto">
                <a class="swapa-pdf" href="{{searchContent.PdfDocumentLink}}" target="_blank"></a>
            </div>
        </div>
    </div>
</div>